import React, { useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { doc, getDoc } from "firebase/firestore";
import { fireDB } from "../config";
import { Typography, Box, Avatar, Container, Grid, Chip } from "@mui/material";

const DetailProduct = () => {
  let params = useParams();
  const [products, setProducts] = useState({});

  const [category, setCategory] = useState({});

  async function handleData() {
    const docRef = doc(fireDB, "products", params.productId);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      setProducts({ ...docSnap.data(), id: docSnap.id });
    } else {
      console.log("No such document!");
    }
  }
  async function handleCategory() {
    const docRef = doc(fireDB, "categories", products.category_id);
    const docSnap = await getDoc(docRef);

    if (docSnap.exists()) {
      setCategory({ ...docSnap.data(), id: docSnap.id });
    } else {
      console.log("No such document!");
    }
  }

  React.useEffect(() => {
    handleData();
  }, []);
  useEffect(() => {
    if (products.id) {
      handleCategory();
    }
  }, [products]);

  return (
    <Container sx={{ m: 2 }} maxWidth="lg">
      {products.id ? (
        <Grid container spacing={2}>
          <Grid item xs={12} sm={6} md={6}>
            <Avatar
              src={products.image}
              sx={{ width: "100%", height: "100%", objectfit: "contain" }}
              variant="rounded"
            />
          </Grid>
          <Grid item xs={12} sm={6} md={6}>
            <Typography variant="h4"> {products.name}</Typography>
            <Chip
              avatar={<Avatar alt="Natacha" src={category.category_img} />}
              label={category.title}
              variant="outlined"
            />
            <Typography variant="h6">Price: ${products.price}</Typography>

            <Typography variant="subtitle2">{products.description}</Typography>
            {products?.sizes?.length ? (
              <Typography variant="h6">Sizes:</Typography>
            ) : null}
            {products?.sizes?.map((item, index) => (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "40%",
                }}
                key={index}
              >
                <Typography variant="subtitle2">{item.name}</Typography>
                <Typography variant="subtitle2">{item.price}</Typography>
              </Box>
            ))}
            {products?.flavours?.length ? (
              <Typography variant="h6">Flavours:</Typography>
            ) : null}
            {products?.flavours?.map((item, index) => (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "40%",
                }}
                key={index}
              >
                <Typography variant="subtitle2">{item.name}</Typography>
              </Box>
            ))}
            {products?.extras?.length ? (
              <Typography variant="h6">Extra:</Typography>
            ) : null}
            {products?.extras?.map((item, index) => (
              <Box
                sx={{
                  display: "flex",
                  justifyContent: "space-between",
                  width: "40%",
                }}
                key={index}
              >
                <Typography variant="subtitle2">{item.name}</Typography>
                <Typography variant="subtitle2">{item.price}</Typography>
              </Box>
            ))}
          </Grid>
        </Grid>
      ) : (
        <Typography variant="h5">
          Loading...</Typography>
      )}
    </Container>
  );
};

export default DetailProduct;
